import { registerComponent } from '@gig/magic-common';
import SweepstakesSsnComponent from './sweepstakes-ssn.vue.js';

var SweepstakesSsn = registerComponent(SweepstakesSsnComponent);

export { SweepstakesSsn };
